// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomePromptController from "./home_prompt_controller"
application.register("home-prompt", HomePromptController)

import IframePreviewController from "./iframe_preview_controller"
application.register("iframe-preview", IframePreviewController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import PreviewPollController from "./preview_poll_controller"
application.register("preview-poll", PreviewPollController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import SchedulePanelController from "./schedule_panel_controller"
application.register("schedule-panel", SchedulePanelController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UserWidgetEditorController from "./user_widget_editor_controller"
application.register("user-widget-editor", UserWidgetEditorController)

import WidgetDefinitionFormController from "./widget_definition_form_controller"
application.register("widget-definition-form", WidgetDefinitionFormController)
